<template>
  <div>
    <b-container fluid>
      <b-row align-h="between">
        <h1>フレームタイプ</h1>
        <button
          class="btn btn-outline-secondary"
          @click="pageBack"
        >戻る</button>
      </b-row>
      <b-table
        :fields="fields"
        :items="communicationTriggers"
        bordered
      >
        <template v-slot:cell(delete)="data">
          <b-row align-h="around">
            <button
              v-if="data.item.communication_trigger!=='定常通信'"
              @click="deleteCommunicationTrigger(data)"
              class="btn btn-outline-danger"
            >削除</button>
          </b-row>
        </template>
      </b-table>
      <b-row align-h="center">
        <b-col sm=6>
          <b-card title="システム機能分類追加">
            <small>※番号は自動で採番されます</small>
            <b-form-group
              label="システム機能分類"
              label-for="add_communication_trigger"
              label-cols=3
            >
              <b-form-input
                v-model="addCommunicationTriggerName"
                id="add_communication_trigger"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="createCommunicationTriggerName"
            >追加</button>
          </b-card>
        </b-col>
        <b-col sm=6>
          <b-card title="システム機能分類更新">
              <b-form-group
                label="番号"
                label-for="update_communication_trigger"
                label-cols=3
              >
              <b-form-input
                v-model="updateCommunicationTrigger.no"
                id="update_communication_trigger_no"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="名称"
              label-for="update_communication_trigger"
              label-cols=3
            >
              <b-form-input
                v-model="updateCommunicationTrigger.name"
                id="update_communication_trigger_name"
              ></b-form-input>
            </b-form-group>
            <button
              class="btn btn-outline-info"
              @click="updateCommunicationTriggerName"
            >更新</button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'CommunicationTrigger',
  data () {
    return {
      communicationTriggers: [],
      fields: [
        { key: 'no', label: '番号', sortable: true },
        { key: 'communication_trigger', label: 'システム機能分類', sortable: true },
        { key: 'delete', label: '削除/更新' }
      ],
      addCommunicationTriggerName: '',
      showRegister: false,
      updateCommunicationTrigger: {
        no: '',
        name: ''
      }
    }
  },
  async created () {
    this.listCommunicationTriggers()
  },
  methods: {
    async listCommunicationTriggers () {
      const funcClasses = await API.graphql(graphqlOperation(`
        query listCommunicationTrigger {
          listCommunicationTrigger{
            no
            communication_trigger
          }
        }
      `))
      this.$log.debug(funcClasses)
      this.communicationTriggers = [...funcClasses.data.listCommunicationTrigger]
    },
    async deleteCommunicationTrigger (args) {
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation deleteCommunicationTrigger {
            deleteCommunicationTrigger (
              no: ${args.item.no}
            ){
              no
              communication_trigger
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '削除に成功しました', 'info')
        this.listCommunicationTriggers()
      } catch {
        this.makeToast('失敗', '削除に失敗しました', 'danger')
      }
    },
    async createCommunicationTriggerName () {
      if (this.addCommunicationTriggerName === '') {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation createCommunicationTrigger {
            createCommunicationTrigger (
              communication_trigger: "${this.addCommunicationTriggerName}"
            ){
              no
              communication_trigger
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '追加に成功しました', 'info')
        this.addCommunicationTriggerName = ''
        this.listCommunicationTriggers()
      } catch {
        this.makeToast('失敗', '追加に失敗しました', 'danger')
      }
    },
    async updateCommunicationTriggerName () {
      if (this.updateCommunicationTrigger.no === '' || this.updateCommunicationTrigger.name === '') {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
        return
      }
      if (this.updateCommunicationTrigger.no === '2') {
        this.makeToast('失敗', '定常通信は変更できません', 'danger')
        return
      }
      try {
        const response = await API.graphql(graphqlOperation(`
          mutation updateCommunicationTrigger {
            updateCommunicationTrigger (
              input:{
                no: ${this.updateCommunicationTrigger.no}
                communication_trigger: "${this.updateCommunicationTrigger.name}"
              }
            ){
              no
              communication_trigger
            }
          }
        `))
        this.$log.debug(response)
        this.makeToast('成功', '更新に成功しました', 'info')
        this.addCommunicationTriggerName = ''
        this.listCommunicationTriggers()
      } catch {
        this.makeToast('失敗', '更新に失敗しました', 'danger')
      }
    },
    pageBack () {
      this.$router.go(-1)
    }
  }
}
</script>
